// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2898": "67f618600057","3006": "c5c5bb654ece","3924": "e6ae595a60f9","5336": "5083bc5218c4","9553": "1843e7e30d66",}[chunkId] + ".css"
}